const notificationLabels: Record<string, string> = {
  "document_workflow.approval_requested":
    "Документ ожидает вашего согласования",
  "document_workflow.approval_due_24h": "Срок согласования через сутки",
  "document_workflow.approval_due_2h": "Срок согласования через два часа",
  "document_workflow.approval_overdue": "Срок согласования пропущен",
  "document_workflow.approval_result": "Результат согласования документа",
  "document_workflow.approval_task_redirected":
    "Задание согласования перенаправлено",
  "document_workflow.substitution_started": "Началось замещение сотрудника",
  "document_workflow.substitution_ended": "Замещение сотрудника завершено",
  "document_workflow.due_24h": "Срок исполнения через сутки",
  "document_workflow.due_2h": "Срок исполнения через два часа",
  "document_workflow.overdue": "Срок исполнения пропущен",
};

/** Подпись сервера приоритетна; словарь нужен для старых ответов и ленты. */
export function notificationTypeLabel(
  type: string,
  serverLabel?: string,
): string {
  if (serverLabel && serverLabel !== type) return serverLabel;
  return (
    notificationLabels[type] ??
    (type.startsWith("document_workflow.")
      ? "Документооборот"
      : "Системное уведомление")
  );
}
